export const PestOrTracesCell: React.FC<{ value: string | null | number }> = ({ value }) => {
  if (value) {
    return <>{value}</>;
  } else {
    return <h6 className="text-danger text-center">-</h6>;
  }
};
